import * as angular from 'angular';
import {IController} from "angular";

export class ContractsAssignAccountsDialogViewCtrl implements IController {
  excludedAccountIds: any;
  selectedIds: string[];
  onSelectedAccountsChanged: Function;

}

angular
  .module(
    'bringoz.admin.contracts'
  )
  .component('contractsAssignAccountsDialogView', {
      bindings: {
        excludedAccountIds: '<',
        selectedIds: '<',
        onSelectedAccountsChanged: '&'
      },
      template: require('./contracts-assign-accounts-dialog-view.html').default,
      controller: ContractsAssignAccountsDialogViewCtrl
    }
  );
